<div data-test="GIjiNVw5" class="md-modal-title">
  <div data-test="VHt2OXJC" class="md-modal-title-inner">
    <div data-test="Sub1L-uJ" class="modal__title">
      <h2 data-test="vdJnJT2W">New assignment review</h2>
    </div>
  </div>
</div>
<ng-container *ngIf="form$">
  <div data-test="6jigKAR9" class="md-modal-content">
    <form data-test="_KCad7We" [ngrxFormState]="form$">
      <div data-test="0PRz-Ogo" class="content_item">
        <span data-test="6Q7deHmv">Date</span>
        <div
          data-test="ZixpKIH8"
          class="form-group__field form-group__field_prepend form-group__field_append"
        >
          <md-datepicker
            data-test="QVlGVcNa"
            [ngrxFormControlState]="form$.controls.date"
            [defaultValue]="form$.value.date"
            *mdAutorun
            [inputStyles]="{ 'padding-left': '10px', height: '36px' }"
            (dateChange)="onDateValueChange($event)"
          ></md-datepicker>
        </div>
      </div>
      <div data-test="Lqyavcp5" class="content_item">
        <span data-test="1c8CLCAa">Start time</span>
        <div data-test="9CgZo1Ic" class="form-group__field form-group__field_prepend">
          <div data-test="RtzK9Zuz" class="form-group__field">
            <input
              data-test="JqzPNGjz"
              class="input input_sm"
              mask="Hh:m0"
              [ngrxFormControlState]="form$.controls.startTime"
              (input)="onStartTimeValueChange($event)"
              [dropSpecialCharacters]="false"
              autocomplete="on"
              placeholder="--:--"
            />
            <label data-test="qYXE74xy" class="form-group__field-prepend link-light">
              <svg
                data-test="fiePp3gq"
                class="icon__icon-calendar-2"
                width="14px"
                height="13px"
              >
                <use xlink:href="#icon-time-3"></use>
              </svg>
            </label>
          </div>
        </div>
      </div>
      <div data-test="Rg0LDKMs" class="content_item">
        <span data-test="zRRiwto5">End time</span>
        <div data-test="BR6sQl0n" class="form-group__field form-group__field_prepend">
          <div data-test="-NttGf5X" class="form-group__field">
            <input
              data-test="ZkyLGNiz"
              class="input input_sm"
              mask="Hh:m0"
              [ngrxFormControlState]="form$.controls.endTime"
              [defaultValue]="form$.controls.date"
              [dropSpecialCharacters]="false"
              [size]="5"
              [disabled]="true"
              autocomplete="off"
              placeholder="--:--"
            />
            <label data-test="6_LNf50O" class="form-group__field-prepend link-light">
              <svg
                data-test="xWfcYvAh"
                class="icon__icon-calendar-2"
                width="14px"
                height="13px"
              >
                <use xlink:href="#icon-time-3"></use>
              </svg>
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-container>
<div data-test="kOVrVEFq" class="md-modal-actions">
  <md-modal-actions data-test="fSHHKhtP">
    <div data-test="iZRCBVX4" class="col-auto m-auto text-center">
      <button
        data-test="SpgtMUvb"
        class="button button_primary button_large button_uppercase"
        (click)="rejectTimeslot()"
      >
        Reject
      </button>
      <button
        data-test="-DAOstOU"
        class="button button_primary button_large button_uppercase"
        (click)="confirmTimeslot()"
      >
        Confirm
      </button>
    </div>
  </md-modal-actions>
</div>
